import { Reducer } from "../../lib/redux";
import { CacheActions } from "./actions";
import { CacheActionTypes, ICacheStore } from "./types";

export const cache: Reducer<ICacheStore, CacheActions> = (state = {}, action) => {
    switch (action.type) {
        case CacheActionTypes.ADD_CACHE_ENTITY: {
            const userId = action.payload.userId;
            const cacheType = action.payload.cacheType;
            const cacheData = action.payload.entities;
            if (userId) {
                return {
                    ...state,
                    [userId]: {
                        ...state[userId],
                        [cacheType]: cacheData
                    }
                };
            }
            return state;
        }
        case CacheActionTypes.CLEAR_CACHE: {
            const userId = action.payload.userId;
            const cacheType = action.payload.cacheType;
            if (!userId) {
                return state;
            }
            let newState = { ...state };
            if (newState[userId] !== undefined) {
                delete newState[userId][cacheType];
            }
            return newState;
        }
        case CacheActionTypes.CLEAR_ALL_CACHES_FOR_USER: {
            const userId = action.payload;
            if (!userId) {
                return state;
            }
            let newState = { ...state };
            if (newState[userId] !== undefined) {
                delete newState[userId];
            }
            return newState;
        }
        case CacheActionTypes.CLEAR_ALL_CACHES: {
            return {};
        }
        default:
            return state;
    }
};